import React from "react";
import { Heart } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { toast } from "sonner";

export function FavouriteButton({ businessId, className = "" }) {
  const { customer, favIds, toggleFav, loginWithGoogle } = useCustomerAuth();
  const isFav = favIds.includes(businessId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!customer) {
      toast.info("Login to save your favourite places");
      loginWithGoogle();
      return;
    }
    toggleFav(businessId);
  };

  return (
    <button
      onClick={onClick}
      className={`w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow hover:scale-110 transition-transform ${className}`}
      title={isFav ? "Remove from favourites" : "Save to favourites"}
      data-testid={`fav-btn-${businessId}`}
    >
      <Heart className={`w-4 h-4 ${isFav ? "fill-primary text-primary" : "text-foreground"}`} />
    </button>
  );
}
